/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GenerateIbanCinRequest } from '../../models/generate-iban-cin-request';
import { GenerateIbanCinResponse } from '../../models/generate-iban-cin-response';

export interface PostApiCustomerV1GenerateIbanCin$Json$Params {

/**
 * Optional Impersonation User header
 */
  'X-Impersonated-User'?: string;
  
    /**
     * IBAN and CIN generation input.
     */
    body?: GenerateIbanCinRequest
}

export function postApiCustomerV1GenerateIbanCin$Json(http: HttpClient, rootUrl: string, params?: PostApiCustomerV1GenerateIbanCin$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<GenerateIbanCinResponse>> {
  const rb = new RequestBuilder(rootUrl, postApiCustomerV1GenerateIbanCin$Json.PATH, 'post');
  if (params) {
    rb.header('X-Impersonated-User', params['X-Impersonated-User'], {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GenerateIbanCinResponse>;
    })
  );
}

postApiCustomerV1GenerateIbanCin$Json.PATH = '/private/v1/customers/generate-iban-cin';
